import PlusOutlined from '@ant-design/icons/lib/icons/PlusOutlined'
import { Button, Form, Input, Modal, message } from 'antd'
import { observer } from 'mobx-react'
import React, { useEffect } from 'react'
import validator from '../../../validator'
import renameDocumentStore from './renameDocumentStore'

const getFileExtension = filename => {
  const lastDot = filename?.lastIndexOf('.')
  if (!lastDot || lastDot === -1) return ''
  return filename.substring(lastDot)
}

const getFileNameWithoutExtension = filename => {
  const ext = getFileExtension(filename)
  if (!ext) return filename
  return filename.substring(0, filename.length - ext.length)
}

const RenameDocumentModal = props => {
  const { visible, onClose, currentDocument } = props
  const { isLoading } = renameDocumentStore
  const [form] = Form.useForm()
  const fileExtension = getFileExtension(currentDocument?.name)

  useEffect(() => {
    return () => {
      renameDocumentStore.clearStore()
    }
  }, [])

  useEffect(() => {
    form.setFieldsValue({
      object_name: getFileNameWithoutExtension(currentDocument?.name),
    })
  }, [currentDocument])

  const onFinish = async values => {
    const { object_name } = values
    const fullName = object_name + fileExtension // Ghép lại tên + đuôi file gốc
    await renameDocumentStore.rename(fullName, currentDocument.id).catch(e => {
      message.error(e?.vi || 'Đã có lỗi xảy ra!')
    })
    closeAndResetForm()
  }

  const closeAndResetForm = () => {
    form.resetFields()
    onClose()
  }

  return (
    <Modal
      footer={null}
      closable={true}
      visible={visible}
      onCancel={closeAndResetForm}
      title="Đổi tên tài liệu">
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="object_name"
          rules={[
            { required: true, message: 'Vui lòng nhập tên tài liệu!' },
            { validator: validator.validateInputString },
          ]}
          label="Tên tài liệu:">
          <Input
            placeholder="Nhập tên tài liệu"
            addonAfter={fileExtension || undefined} // Hiển thị đuôi file cố định
          />
        </Form.Item>
        <Form.Item>
          <Button
            icon={<PlusOutlined />}
            loading={isLoading}
            htmlType="submit"
            type="primary">
            Đổi tên
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default observer(RenameDocumentModal)
